import { useMemo } from "react"
import { Plus } from "lucide-react"
import { Page, Button } from "./ui"
import { SegmentedControl, KpiTile, KpiStrip, en } from "procurement/design"
import ItemsListView from "./components/items/ItemsListView"
import ItemGroupsView from "./components/items/ItemGroupsView"
import ItemStockView from "./components/items/ItemStockView"
import ItemAvailabilityView from "./components/items/ItemAvailabilityView"
import CategoriesListView from "./components/items/CategoriesListView"
import useProcurementFilters from "./hooks/useProcurementFilters"
import { useNavigate } from "react-router-dom"
import {
  useGetItemsQuery,
  useGetItemGroupsQuery,
  useGetProcurementCentersQuery,
} from "shared/redux/endpoints/procurementItems"

const ItemManagementContainer = () => {
  const navigate = useNavigate()
  const { filters, setFilters } = useProcurementFilters({ tab: "items" })
  const tab = filters.tab || "items"

  const { data: items } = useGetItemsQuery({ size: 10000 })
  const { data: groups } = useGetItemGroupsQuery()
  const { data: centersPage } = useGetProcurementCentersQuery({ size: 200 })

  const activeCount = useMemo(() => (items || []).filter((i) => i.isActive !== false).length, [items])
  const groupCount = (groups || []).length
  const centerCount = centersPage?.items?.length || 0
  // TODO(BE): GET /item-stock has no reorder-point field — cannot compute "below reorder".
  const belowReorder = null

  return (
    <Page
      className="pc-page--refined pc-page--list"
      breadcrumb={["Procurement", "Items"]}
      title={en.items.title}
      subtitle={en.items.subtitle}
      actions={
        <Button variant="primary" leftIcon={<Plus aria-hidden />} onClick={() => navigate("/procurement/items/new")}>
          {en.items.newItem}
        </Button>
      }
    >
      <SegmentedControl
        value={tab}
        onChange={(v) => setFilters({ tab: v })}
        options={[
          { value: "items", label: en.items.tabItems },
          { value: "groups", label: en.items.tabGroups },
          { value: "stock", label: en.items.tabStock },
          { value: "availability", label: en.items.tabAvailability },
          { value: "categories", label: en.items.tabCategories },
        ]}
      />

      <KpiStrip>
        <KpiTile label={en.items.activeItems} value={activeCount} hint={en.common.inCurrentList} />
        <KpiTile label={en.items.itemGroups} value={groupCount} hint={en.common.inCurrentList} />
        <KpiTile
          label={en.items.belowReorder}
          value={belowReorder == null ? "—" : belowReorder}
          hint="Not available yet"
        />
        <KpiTile label={en.items.centersCovered} value={centerCount} hint={en.common.inCurrentList} />
      </KpiStrip>

      {tab === "items" && <ItemsListView />}
      {tab === "groups" && <ItemGroupsView />}
      {tab === "stock" && <ItemStockView />}
      {tab === "availability" && <ItemAvailabilityView />}
      {tab === "categories" && <CategoriesListView />}
    </Page>
  )
}

export default ItemManagementContainer
